import apiClient from './apiClient';

export interface MedicalRecordFilters {
  from?: string;
  to?: string;
  kind?: string;
  q?: string;
}

export async function getStaffMedicalRecord(animalId: string, filters?: MedicalRecordFilters) {
  const response = await apiClient.get(`/medical-records/animals/${animalId}`, { params: filters });
  return response.data.data;
}

export async function getStaffMedicalSummary(animalId: string) {
  const response = await apiClient.get(`/medical-records/animals/${animalId}/summary`);
  return response.data.data;
}

export async function exportStaffMedicalPdf(animalId: string): Promise<Blob> {
  const response = await apiClient.get(`/medical-records/animals/${animalId}/export/pdf`, {
    responseType: 'blob',
  });
  return response.data as Blob;
}
